import { ITableHeader } from "../../../components/shared/ScrollableTable/ScrollableTable";

export const headers: ITableHeader[] = [
  { name: "name", label: "Name" },
  { name: "email", label: "Email" },
  { name: "datecreated", label: "Date Created" },
];
